<template>
  <!-- 左侧菜单 -->
  <div class="left-menu">
    <div class="left-menu-li">
      <div v-for="(item, index) in routerPath.children" :key="index">
        <div class="left-menu-title">{{ item.meta.title }}</div>
        <div
          class="left-menu-list"
          v-for="(items, indexs) in item.children"
          :key="indexs"
        >
          <router-link
            v-if="!items.hidden"
            :class="[
              'left-menu-item',
              index == indexActive[0] && indexs == indexActive[1]
                ? 'menu-active'
                : '',
            ]"
            :to="{
              path: '/' + routerPath.path + '/' + item.path + '/' + items.path,
            }"
          >
            {{ items.meta.title }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapState } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(["indexActive", "routerPath"]),
  },
};
</script>

<style scoped>
.left-menu {
  background-color: #fff;
  /* background: var(--greyLight-1); */
  height: 100%;
  box-shadow: 0px 3px 6px #f4f6f9;
  padding: 22px 0px;
  box-sizing: border-box;
  overflow: auto;
}
.left-menu-title {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
  padding: 10px 24px;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.left-menu-list {
  display: flex;
  flex-direction: column;
}
.left-menu-item {
  font-size: 14px;
  font-family: 萍方-简;
  font-weight: normal;
  color: #707070;
  /* max-width: 190px; */
  /* border-radius: 20px; */
  padding: 10px 24px;
  box-sizing: border-box;
  cursor: pointer;
  margin: 5px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-left: 6px solid transparent;
  transition: all 0.2s;

  /* color: var(--greyDark);
  border-radius: 12px;
  box-shadow: 0.3rem 0.3rem 0.6rem var(--greyLight-2),
    -0.2rem -0.2rem 0.5rem var(--white);
  justify-self: center;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.3s ease; */
}
/* .left-menu-item:active{
  box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);
} */
.left-menu-item:hover {
  background: rgba(210, 222, 244, 0.34);
  color: #1f5bcc;
  /* border-left: 6px solid #1f5bcc; */
}
.menu-active {
  background: rgba(210, 222, 244, 0.34);
  color: #1f5bcc;
  border-left: 6px solid #1f5bcc;
  /* box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white); */
}
</style>